import { getRequestListLight } from '../../../../api'
import {
  getAsyncSelectShowSelectedApiParamIdPK,
  InputAsyncSelect as InputAsyncSelectComponent,
  InputMultiSelectControl,
  MultiSelect,
} from '../../../Select'
import { Container } from '../../Container'
import { useSelectState } from '../Selects.hooks'
import {
  getRequestItemTagText,
  toRequestAsyncSelectItems,
} from '../Selects.utils'

import ServiceRequestIcon from '../../../../icons/service-request.svg'

function InputAsyncMultiSelectWithTags() {
  const {
    handleClear,
    handleClickTagClearButton,
    handleSelectAll,
    handleSelectItem,
    value,
  } = useSelectState({ multi: true })

  return (
    <Container label='Async input multi select without search input inside dropdown and value items tags'>
      <MultiSelect
        Control={InputMultiSelectControl}
        EntityIcon={ServiceRequestIcon}
        Select={InputAsyncSelectComponent}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: 'Select',
            },
          },
        }}
        getData={getRequestListLight}
        getShowSelectedApiParam={getAsyncSelectShowSelectedApiParamIdPK}
        style={{ width: 240 }}
        tagsProps={{
          getText: getRequestItemTagText,
          onChange: handleClickTagClearButton,
          onClear: handleClear,
        }}
        toPreparedItems={toRequestAsyncSelectItems}
        value={value}
        onClear={handleClear}
        onSelectAll={handleSelectAll}
        onSelectItem={handleSelectItem}
      />
    </Container>
  )
}

export default InputAsyncMultiSelectWithTags
